import BaseInput from '@/components/Argon/InputsBootstrap/BaseInput.vue';
import BaseDropdown from '@/components/Argon/BaseDropdown.vue';
import Card from '@/components/Argon/Cards/Card.vue';
import Modal from '@/components/Argon/Modal.vue';
import StatsCard from '@/components/Argon/Cards/StatsCard.vue';
import BaseButton from '@/components/Argon/BaseButton.vue';
import Badge from '@/components/Argon/Badge.vue';
import BaseCheckbox from '@/components/Argon/InputsBootstrap/BaseCheckbox.vue';
import BaseRadio from "@/components/Argon/InputsBootstrap/BaseRadio";
import BaseProgress from "@/components/Argon/BaseProgress";
import BasePagination from "@/components/Argon/BasePagination";
import BaseAlert from "@/components/Argon/BaseAlert";
import BaseNav from "@/components/Argon/Navbar/BaseNav";
import BaseHeader from '@/components/Argon/BaseHeader';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Input, Tooltip, Popover } from 'element-ui';
/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(Card.name, Card);
    Vue.component(Modal.name, Modal);
    Vue.component(StatsCard.name, StatsCard);
    Vue.component('ElInput', Input);
    Vue.component('validation-provider', ValidationProvider)
    Vue.component('validation-observer', ValidationObserver)
    Vue.use(Tooltip);
    Vue.use(Popover);
  }
};

export default GlobalComponents;
